// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FILE_IS_TOO_BIG = "Soubor je p\u0159\u00edli\u0161 velk\u00fd.";
export const WRONG_IMAGE_FORMAT = "\u0160patn\u00fd typ. M\u011bl by m\u00edt p\u0159\u00edponu JPG.";
